module.exports = __webpack_public_path__ + "static/media/loc1_img26.9a4886df.jpg";